module.exports = __webpack_public_path__ + "7da408a4de4bf46137c4331a427b6a3e.svg";